import { useTheme } from '@mui/material';
const useCustomDialogStyles = (backgroundVariant = 'white') => {
    const theme = useTheme();
    const getBackgroundColor = () => {
        switch (backgroundVariant) {
            case 'grey':
                return theme.palette.common.white92;
            case 'white':
            default:
                return theme.palette.common.white;
        }
    };
    return {
        dialogContainer: {
            borderRadius: (theme) => theme.spacing(4),
            p: (theme) => theme.spacing(1),
            backgroundColor: getBackgroundColor(),
            backdropFilter: backgroundVariant === 'grey' ? 'blur(20px)' : 'none',
            backgroundImage: 'none' // Remove any default gradient
        }
    };
};
export default useCustomDialogStyles;
